<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <div class="basicInfo">
        <div>商户名称：{{ name }}</div>
        <div>申请单编号：{{ progressData.applymentId }}</div>
      </div>
      <div class="audit_result">
        <h4>审核结果： <span v-if="progressData.auditDetail.length">驳回</span></h4>
        <div class="result" v-for="(item, index) of progressData.auditDetail" :key="index">
          <p v-if="item.fieldName">错误信息：{{ item.fieldName }}</p>
          <p><span>错误详情：</span>{{ item.rejectReason }}</p>
        </div>
      </div>
      <div>
        <div class="steps">
          <span class="btn"
            ><el-button type="text" size="small" @click="handleDetails"> 查看申请单资料 </el-button>
          </span>
          <div class="img">
            <el-image :src="progressData.signUrl" alt="" style="width: 78px; height: 78px"></el-image>
          </div>
          <el-steps direction="vertical" :active="2" :space="150">
            <el-step title="提交申请" :description="createTime"></el-step>
            <el-step
              title="平台审核"
              description="若需将申请单进度通知给特约商户，可让申请单的超级管理员#超级管理员姓名#使用微信扫以下二维码，完成核对联系信息。进度通知将通过“微信支付商家助手”公众号推送。"
            ></el-step>
            <el-step title="签署协议"></el-step>
          </el-steps>
        </div>
      </div>
      <div><el-button type="info" @click="back">返回</el-button></div>
    </div>
  </div>
</template>

<script>
import { queryApplication } from '../../../../api/module/merchants';

export default {
  components: {},
  props: {},
  data() {
    return {
      progressData: '',
    };
  },
  computed: {
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
    name() {
      return this.$route.query.name;
    },
    createTime() {
      return this.$route.query.createTime;
    },
  },
  watch: {},
  created() {
    this.queryApplication();
  },
  methods: {
    async queryApplication() {
      const { uuid, merchantId } = this;
      const result = await queryApplication({
        uuid,
        merchantId,
      });
      this.progressData = result;
      console.log('回显所填信息', result);
    },
    handleDetails() {
      this.$router.push({
        path: '/merchants/viewDetails',
        query: {
          uuid: this.uuid,
        },
      });
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  box-sizing: border-box;
  padding: 20px;
  .basicInfo {
    height: 50px;
    color: #333;
    font-weight: 500;
    font-size: 12px;
    display: flex;
    div {
      margin-right: 180px;
    }
  }
  .steps {
    position: relative;
    .btn {
      position: absolute;
      left: 110px;
      color: #000;
      top: -3px;
    }
    .img {
      position: absolute;
      left: 40px;
      bottom: 160px;
    }
  }
  .audit_result {
    h4 {
      span {
        font-size: 16px;
        color: orangered;
      }
    }
    .result {
      width: 80%;
      margin-bottom: 30px;
    }
    p {
      color: red;
      font-size: 14px;
      line-height: 20px;
      margin-top: 15px;
      span {
        color: #000;
      }
    }
  }
}
</style>
